"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListWidget_1 = require("../../components/ListWidget");
ListWidget_1.ListWidget.each('.manage-interests', {
    eventNS: 'interest',
    busBindings: {
        handleAdd: 'interest.added',
        handleDelete: 'interest.deleted'
    }
});
